import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
            <i className="ri-chat-quote-line mr-1"></i>读者评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            读者口碑
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            听听资深读者怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="relative bg-background-50 rounded-2xl p-6 md:p-8"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-foreground-950">{t.name}</span>
                    <span className="flex items-center gap-0.5 text-accent-500 text-xs">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{t.role}</span>
                </div>
              </div>

              <div className="relative">
                <i className="ri-double-quotes-l text-3xl text-primary-200 absolute -top-1 -left-1"></i>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-6 italic">
                  {t.quote}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { value: '5000+', label: '收录漫画' },
            { value: '300万+', label: '月活读者' },
            { value: '99.9%', label: '服务可用率' },
            { value: '4.8', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-4">
              <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-400 mt-1">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}